import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Design, CampaignTabBar } from './components';
import useCampaign from './useCampaign';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: theme.spacing(3)
  }
}));

const CampaignDesign = props => {
  const { className, staticContext, ...rest } = props;
  const campaign = useCampaign('/campaign/automation', '/campaign/recipients');
  const templates = useSelector(store => store.template.list);
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CampaignTabBar onTabChange={campaign.onTabChange} />
      <div className={classes.content}>
        <Design campaign={campaign} templates={templates} showNav={true} />
      </div>
    </div>
  );
};

export default CampaignDesign;
